(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('footer-products-carousel')) {
    class FooterProductsCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.slider = this.querySelector('.footer-products__slider');
        this.items = Array.from(this.querySelectorAll('.footer-products__item'));
        this.currentIndex = 0;

        this.querySelectorAll('[data-footer-direction]').forEach((button) => {
          button.addEventListener('click', () => {
            this.move(button.dataset.footerDirection === 'next' ? 1 : -1);
          });
        });

        this.dataset.ready = 'true';
      }

      visibleItems() {
        if (!this.slider || this.items.length === 0) return 1;

        const firstItemWidth = this.items[0].getBoundingClientRect().width;
        if (firstItemWidth === 0) return 1;

        return Math.max(1, Math.round(this.slider.clientWidth / firstItemWidth));
      }

      move(direction) {
        if (!this.slider || this.items.length < 2) return;

        const maximumIndex = Math.max(0, this.items.length - this.visibleItems());

        if (direction > 0) {
          this.currentIndex = this.currentIndex >= maximumIndex ? 0 : this.currentIndex + 1;
        } else {
          this.currentIndex = this.currentIndex <= 0 ? maximumIndex : this.currentIndex - 1;
        }

        this.items[this.currentIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }
    }

    customElements.define('footer-products-carousel', FooterProductsCarousel);
  }

  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  if (!window.takaaCollectionRevealInitialized) {
    const initTakaaCollectionReveal = (container) => {
      if (!container || container.dataset.revealReady === 'true') return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const revealOnce = container.dataset.animationOnce !== 'false';
      const stagger = Number.parseInt(container.dataset.animationStagger || '80', 10);
      const pageReady = new Promise((resolve) => {
        const revealAfterLoad = () => window.setTimeout(resolve, 220);

        if (document.readyState === 'complete') {
          revealAfterLoad();
        } else {
          window.addEventListener('load', revealAfterLoad, { once: true });
        }
      });

      const observer = reduceMotion ? null : new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            if (revealOnce) observer.unobserve(entry.target);
          } else if (!revealOnce) {
            entry.target.classList.remove('is-visible');
          }
        });
      }, {
        threshold: 0.12,
        rootMargin: '0px 0px -5% 0px'
      });

      const prepareCards = (scope) => {
        scope.querySelectorAll('.card__collection:not(.takaa-scroll-reveal)').forEach((card, index) => {
          card.classList.add('takaa-scroll-reveal');
          card.style.setProperty('--takaa-reveal-delay', `${(index % 6) * stagger}ms`);

          if (reduceMotion) {
            card.classList.add('is-visible');
          } else {
            pageReady.then(() => {
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  observer.observe(card);
                });
              });
            });
          }
        });
      };

      container.classList.add('takaa-scroll-enabled');
      prepareCards(container);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          container.classList.add('takaa-scroll-armed');
        });
      });

      new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;
            if (node.matches?.('.card__collection')) prepareCards(node.parentElement || container);
            prepareCards(node);
          });
        });
      }).observe(container, { childList: true, subtree: true });

      container.dataset.revealReady = 'true';
    };

    const initAllTakaaCollectionReveals = (scope = document) => {
      scope.querySelectorAll('[data-takaa-scroll-collections]').forEach(initTakaaCollectionReveal);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllTakaaCollectionReveals());
    } else {
      initAllTakaaCollectionReveals();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllTakaaCollectionReveals(event.target);
    });

    window.takaaCollectionRevealInitialized = true;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bottom-navigation"]) return;
  try {
    
  if (!window.takaaMobileBottomNavBound) {
    document.addEventListener('click', (event) => {
      const cartButton = event.target.closest('[data-takaa-cart-drawer]');
      if (cartButton) {
        const cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer) {
          event.preventDefault();
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
            detail: { opener: cartButton }
          }));
        }
        return;
      }

      const accountButton = event.target.closest('[data-takaa-account-link]');
      if (accountButton) {
        event.preventDefault();
        const href = accountButton.getAttribute('href');
        if (href && href !== '#') window.location.assign(href);
        return;
      }

      const menuButton = event.target.closest('[data-takaa-main-menu]');
      if (menuButton) {
        event.preventDefault();
        const headerMenuToggle = document.querySelector('#takaa-sticky-header-group .main-menu__toggle, .cc-header .main-menu__toggle');
        if (headerMenuToggle) {
          headerMenuToggle.click();
        }
      }
    });

    window.takaaMobileBottomNavBound = true;
  }

  } catch(e) { console.error(e); }
})();
})();
